/** MT4 dashboard from MySQL replica (MT4_TRADES / MT4_USERS). */
import { appendTokenSearchParams, buildAuthHeaders, formatApiError, getApiToken, normalizeApiBase } from './auth';

const API_BASE = normalizeApiBase();

export async function fetchDashboardMt4Overview({
  segment = 'wh',
  period = 'today',
  startDate,
  endDate,
  depositStartDate,
  depositEndDate,
  signal,
} = {}) {
  if (!getApiToken()) {
    throw new Error(
      'Missing API token — set REACT_APP_API_TOKEN in websocket/.env (same as EXPECTED_TOKEN)'
    );
  }

  const params = appendTokenSearchParams(new URLSearchParams({ period, segment }));
  if (startDate && endDate) {
    params.set('start_date', startDate);
    params.set('end_date', endDate);
  }
  if (depositStartDate && depositEndDate) {
    params.set('deposit_start_date', depositStartDate);
    params.set('deposit_end_date', depositEndDate);
  }

  const res = await fetch(`${API_BASE}/api/dashboard/mt4/overview?${params}`, {
    headers: buildAuthHeaders(),
    signal,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(formatApiError(err, res.status));
  }
  return res.json();
}
